interface SafeDocumentUrlParams {
  readonly baseUrl: string;
  readonly downloadUrl: string;
}

export function toSafeDocumentUrl(
  params: SafeDocumentUrlParams,
): string | null {
  try {
    const parsedUrl = new URL(params.downloadUrl, params.baseUrl);
    return parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:"
      ? parsedUrl.href
      : null;
  } catch {
    return null;
  }
}
